import classnames from 'classnames';
import MarkdownRender from 'components/MarkdownRender/MarkdownRender';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import ReactCommonmark from 'react-commonmark';
import checkIconFilled from 'v2//icons/checkIconFilled.svg';
import crossIconFilled from 'v2/icons/crossIconFilledRed.svg';
import { ProposalEntity, SearchEntity } from 'v2/models';
import { get_data_buyer_description } from 'v2/utils/proposalUtils';
import NomadGuidance from '../DataRequests/NomadGuidance/NomadGuidance';

interface StepOneProps {
  proposal: ProposalEntity;
  onReject: () => Promise<void>;
  onContinueClick: () => void;
}

const StepOne = ({ proposal, onReject, onContinueClick }: StepOneProps) => {
  const [busy, setBusy] = useState(false);
  const search = proposal.search as SearchEntity;
  const [showMore, setShowMore] = useState(false);

  const rejectProposal = async () => {
    setBusy(true);
    await onReject();
    setBusy(false);
  };

  return (
    <div className="p-5">
      <label className="text-primary-dark">{search.name}</label>
      <div className={classnames({ 'multiline-truncate-4': !showMore })}>
        <MarkdownRender
          className="text-light4"
          source={search.description}
          format={false}
          preserveSpaces
        />
      </div>
      {showMore ? (
        <div className="pt-4">
          <label className="text-primary-dark">Client Description</label>
          <ReactCommonmark
            className="text-light4"
            source={get_data_buyer_description(proposal) || ''}
            softBreak="br"
          />
        </div>
      ) : null}

      <Button
        className="p-0 mt-2"
        variant="link"
        onClick={() => setShowMore(!showMore)}
      >
        {showMore ? 'Show Less' : 'Show More'}
      </Button>

      <NomadGuidance proposal={proposal} />

      <div className="mt-4 d-flex">
        <Button
          variant="danger"
          className="mr-3"
          onClick={rejectProposal}
          disabled={busy}
        >
          <img
            className="mr-2"
            src={crossIconFilled}
            alt="rejectProposalIcon"
          ></img>
          Not a match
        </Button>
        <Button variant="secondary" onClick={onContinueClick} disabled={busy}>
          <img
            className="mr-2"
            src={checkIconFilled}
            alt="startConversationIcon"
          ></img>
          I have that data!
        </Button>
      </div>
    </div>
  );
};

export default StepOne;
